// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-wrapper .slick-arrow {
  display: none !important;
}
.chart-wrapper .slick-list {
  border-radius: 8px;
  background-color: #ffffff;
  padding-top: 10px !important;
}
@media (min-width: 768px) {
  .chart-wrapper .slick-list {
    padding: 0;
  }
}
.chart-wrapper .slick-dots li {
  margin: 0 5px;
  height: 0;
}
.chart-wrapper .slick-dots li button {
  background-color: #005eb8;
  border-radius: 40%;
  opacity: 1;
  width: 10px;
  height: 10px;
  transition: 0.3s;
  font-size: 1px;
}
.chart-wrapper .slick-dots li button:before {
  content: none;
}
.chart-wrapper .slick-dots li.slick-active button {
  background-color: #005eb8;
  width: 18px;
}
.chart-wrapper .chart-slide {
  padding: 10px;
}
.chart-wrapper .chart-slide .chart-bar {
  display: flex;
  justify-content: center;
}
.chart-wrapper .chart-slide .chart-bar canvas {
  max-width: 100%;
  height: auto;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/chart/index.scss"],"names":[],"mappings":"AACE;EACE,wBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;AADJ;AAGI;EALF;IAMI,UAAA;EAAJ;AACF;AAII;EACE,aAAA;EACA,SAAA;AAFN;AAIM;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAFR;AAIQ;EACE,aAAA;AAFV;AAOQ;EACE,yBAAA;EACA,WAAA;AALV;AAWE;EACE,aAAA;AATJ;AAWI;EACE,aAAA;EACA,uBAAA;AATN;AAWM;EACE,eAAA;EACA,YAAA;EACA,cAAA;AATR","sourcesContent":[".chart-wrapper {\n  .slick-arrow {\n    display: none !important;\n  }\n\n  .slick-list {\n    border-radius: 8px;\n    background-color: #ffffff;\n    padding-top: 10px !important;\n\n    @media (min-width: 768px) {\n      padding: 0;\n    }\n  }\n\n  .slick-dots {\n    li {\n      margin: 0 5px;\n      height: 0;\n\n      button {\n        background-color: #005eb8;\n        border-radius: 40%;\n        opacity: 1;\n        width: 10px;\n        height: 10px;\n        transition: 0.3s;\n        font-size: 1px;\n\n        &:before {\n          content: none;\n        }\n      }\n\n      &.slick-active {\n        button {\n          background-color: #005eb8;\n          width: 18px;\n        }\n      }\n    }\n  }\n\n  .chart-slide {\n    padding: 10px;\n\n    .chart-bar {\n      display: flex;\n      justify-content: center;\n\n      canvas {\n        max-width: 100%;\n        height: auto;\n        display: block;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
